import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useLanguagesList() {

    //User toast
    const toast = useToast()

    const refLanguageListTable = ref(null)

    const tableColumns = [
        {key: 'id', sortable: true},
        {key: 'language_name'},
        {key: 'language_remark'},
        {key: 'action'}
    ]

    const perPage = ref(10)
    const totalLanguages = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refLanguageListTable.value ? refLanguageListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalLanguages.value,
        }
    })

    const refetchData = () => {
        refLanguageListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchLanguages = (ctx, callback) => {
        store.dispatch('setting-contract/fetchLanguages',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response =>{
            const {languages, total} = response.data
            callback(languages)
            totalLanguages.value = total
        
        })
        .catch((error) => {
            console.log(error)
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching language list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchLanguages,
        tableColumns,
        perPage,
        currentPage,
        totalLanguages,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refLanguageListTable,
        ability,
        refetchData
    }

}